import React, { ChangeEvent, Component } from 'react';
import { RootState } from '../../../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import FormicaInput from 'components/custom/FormicaInput';
import FormicaLabel from '../../../../custom/FormicaLabel';
import { ActionState } from '../../../../../redux/reducers/ActionReducer';
import { changeAction, changeActionIsUpdate, clearAction } from '../../../../../redux/actions/ActionActions';
import { enterComponent, leaveComponent } from '../../../../../redux/actions/ComponentActions';
import { FormicaProps, withFormica } from '../../../../../helpers/withFormica';
import { ApiActionJsonModel } from '../../../../../domain/collection/rule/action/ActionDomains';
import ComponentName from '../../../../../constant/ComponentName';
import LanguageUtil from '../../../../../util/LanguageUtil';

class BearerAuthComponent extends Component<Props, State> {
  public state = new State();

  public render() {
    const { bearerToken } = this.state;
    const { disabled } = this.props;

    return (
      <div className={'w-full h-full flex flex-col'}>
        <div className={'flex flex-col w-full gap-y-2'}>
          <FormicaLabel label={LanguageUtil.get({ id: 'common.label.token', defaultMessage: 'Token' })} />
          <FormicaInput
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeToken(e)}
            disabled={disabled}
            value={'Bearer ' + bearerToken}
            label={LanguageUtil.get({ id: 'common.label.token', defaultMessage: 'Token' })}
            data-testid={`${ComponentName.ACTION}_api_auth_bearer_input`}
          />
        </div>
      </div>
    );
  }

  public componentDidMount() {
    const {
      action: { action },
    } = this.props;
    const token = (action as ApiActionJsonModel).headers?.['Authorization']?.split('Bearer');
    if (token && token.length > 1) {
      this.setState({ bearerToken: token[1].trim() });
    }
  }

  private onChangeToken(e: ChangeEvent<HTMLInputElement>) {
    const {
      action: { action },
      changeAction,
    } = this.props;
    let token = e.target.value;
    if (token.startsWith('Bearer ')) {
      token = e.target.value.replace('Bearer ', '');
    } else token = '';
    if (!(action as ApiActionJsonModel).headers) {
      (action as ApiActionJsonModel).headers = { Authorization: '' };
    }
    (action as ApiActionJsonModel).headers['Authorization'] = 'Bearer ' + token;
    this.setState({ bearerToken: token });
    changeAction(action);
  }
}

interface Props extends ReduxProps, FormicaProps {
  disabled?: boolean;
}

class State {
  bearerToken: string = '';
}

const mapStateToProps = (state: RootState) => ({
  action: state.action as ActionState,
  isUpdate: state.action.isUpdate,
  lastCategory: state.page.lastCategory,
});
const mapDispatchToProps = {
  changeActionIsUpdate,

  changeAction,
  clearAction,
  enterComponent,
  leaveComponent,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(BearerAuthComponent));
